// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'point_price',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'rewardable_type',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'rewardable_name',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'reward_product_category',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'updated_at',
    label: '',
    Object: 'value',
    width: '180'
  }]
}
